import { FC } from 'react';
import ConfigureItemsGrid from '@flows/src/components/flows-configure/shared/ConfigureItemsGrid';
import FlowsConfigureInsuranceItem from '@flows/src/components/flows-configure/insurances/FlowsConfigureInsuranceItem';
import { AnvaFlowsInsurance } from '@flows/src/api/anva-flows/getAnvaFlowsInsurances';
import SelectAllButton from '@flows/src/components/flows-configure/shared/SelectAllButton';
import useFlowsConfigureSelectAllButtonProps from '@flows/src/hooks/flows-configure/useFlowsConfigureSelectAllButtonProps';
import { useFlowsConfigureStore } from '@flows/src/store/zustand/flows-configure/flowsConfigureStore';

interface Props {
  items: AnvaFlowsInsurance[];
  isError?: boolean;
  clearError?: () => void;
}

const FlowsConfigureInsurancesItems: FC<Props> = ({
  items,
  isError,
  clearError,
}) => {
  const { handleDeselectAll, handleSelectAll } =
    useFlowsConfigureSelectAllButtonProps('insurances');
  const isAllSelected = useFlowsConfigureStore(
    (state) => state.insurances?.length === items.length,
  );

  return (
    <ConfigureItemsGrid singleColumn={items.length === 1}>
      {items.length > 1 && (
        <SelectAllButton
          isAllSelected={isAllSelected}
          onDeselectAll={handleDeselectAll}
          onSelectAll={() =>
            handleSelectAll(items?.map((insurance) => insurance.id) || [])
          }
        />
      )}
      {items.map((item) => (
        <FlowsConfigureInsuranceItem
          key={item.id}
          insurance={item}
          isError={isError}
          clearError={clearError}
        />
      ))}
    </ConfigureItemsGrid>
  );
};

export default FlowsConfigureInsurancesItems;
